// resetting a pin
import { apiBaseURL } from "../ProjectConstants";

export async function handlePostUserPin(userId, oldPin, newPin, fetch) {
  const body = {
    UserId: userId,
    OldPin: oldPin,
    NewPin: newPin,
  };
  console.log(" before handlePostUserPin =>", body);

  //   const response = null;
  const response = await fetch.post(`${apiBaseURL}/api/user/pin`, body);
  console.log(" after handlePostUserPin =>", body);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePostUserPin body", body, response);

  return {
    response,
    isDataGood,
  };
}

export async function handlePostCreateUserPin(userId, newPin, fetch) {
  const body = {
    UserId: userId,
    NewPin: newPin,
  };
  console.log(" before handlePostUserPin =>", body);

  //   const response = null;
  const response = await fetch.post(`${apiBaseURL}/api/user/pin`, body);
  console.log(" after handlePostUserPin =>", body);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== "Invalid Model";

  console.log("handlePostUserPin body", body, response);

  return {
    response,
    isDataGood,
  };
}
